import types from '@/store/mutation-types'

const defaultState = {
  perms: null,
}

// getters
const getters = {
  perms: state => state.perms,
}

// actions
const actions = {
  async loadPerms ({ commit }, { perms }) {
    commit(types.ACCESS_UPDATE, { perms })
  },
}

// mutations
const mutations = {
  [types.ACCESS_UPDATE] (state, { perms }) {
    state.perms = perms; // eslint-disable-line
  },
  [types.RESET_STATE] (state) {
    state.perms = null
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
}
